import { AlertTriangle, ShieldAlert } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';

import { useAuditLogsListStore } from '@/store/audit-logs-list.store';

export const AuditLogEmptyResult = () => {
  const { reset, query, filters } = useAuditLogsListStore();

  const hasQuery = (query && query.trim() !== '') || filters.module !== 'All';

  return (
    <EmptyResult
      icon={<ShieldAlert className="h-12 w-12 text-muted-foreground/40" />}
      title="No audit logs found"
      description="New warnings, errors, and activity events will appear here."
      onClear={reset}
      hasQuery={hasQuery}
    />
  );
};

export const AuditLogErrorResult = ({ errorMessage }: { errorMessage?: string }) => {
  const { reset } = useAuditLogsListStore();

  return (
    <EmptyResult
      icon={<AlertTriangle className="h-12 w-12 text-red-500/80" />}
      title="Failed to load audit logs"
      description={errorMessage || 'Try again in a moment.'}
      onClear={reset}
    />
  );
};
